import { Component, Input} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ProductCategory } from 'src/app/assabil-kernel/models/entities/control-tables/product-category-entity';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { GenericLovComponent } from 'src/app/tools/abstract-classes/generic-lov.component';
import { MatDialogRef } from '@angular/material/dialog';



@Component({
    selector: 'product-category-lov',
    templateUrl: './product-category-lov.component.html',
    styleUrls: ['./product-category-lov.component.scss']
})


export class ProductCategoryLovComponent extends GenericLovComponent   {

    @Input() code         : string; 
    @Input() assetOnly    : boolean; 

    productCategories          : ProductCategory[] = [];

    columns = [
        {  prop: 'productCategoryCode', name: 'Code'},
        {  prop: 'name', name: 'Name'               }
    ]

    constructor(
        public dialogRef: MatDialogRef<ProductCategoryLovComponent>,
        protected controlService    : ControlTablesService,
        protected toastr            : ToastrService,
        protected router            : Router,
        protected location          : Location) {
          super();

          this.entityName = 'productCategory';
      }

    
//----------------------------------------------------------------------
loadData() {
    let request: BaseRequest = new BaseRequest(this.controlService.getUserInfo());
        request.strArg1 = this.code;
        request.blnArg1 = this.assetOnly;

        this.controlService.getList(this.entityName, request).then(result => {
            this.productCategories = result;
        })
    }
// ---------------------------------------------------

//----------------------------------------------------------------------
closeModal(row : ProductCategory){
    this.dialogRef.close(row);
}
//----------------------------------------------------------------------


}
